/**
 * Usuariosclientebinarios Archetype
 * 
 * @version 1.2
 * @author Daniel Lepe
 * Agregada la opción de pase de getArgs en alta de definición.
 * 
 * @author Daniel Lepe
 * Agregada la función quicktableFilters y archetypeUsuariosclientebinariosCFG, útiles para filtar en quicktable y 
 * agregar dependencias de configuración Usuariosclientebinarios => Usuariosclientebinarios_hijo respectivamente.
 * @date [date]
 * @version 1.1
 * 
 * @author Daniel Lepe
 * @date [date]
 * @version 1.0
 */

import _ from 'lodash'
import { objectToUrlString } from '@/utils.js'

const baseController = 'Usuariosclientebinarios',
    baseIndex = baseController + '/index',
    archetype = () => {
        return [
            {
                key: 'id_pk',
                type: 'hidden'
            },
            {
                key: 'id_usuario_fk',
                label: 'Usuario',
                type: 'hidden',
                required: true
            },
            {
                key: 'titulo',
                label: 'Título',
                type: 'text',
                required: true
            },
            {
                key: 'url',
                label: 'URL',
                type: 'file',
            },
            {
                key: 'tipo',
                label: 'Tipo',
                type: 'hidden'
            },
            null,
            dispoField,
            null,
            [
                {
                    key: 'created',
                    label: 'Fecha de Creación',
                    type: 'datetime',
                    readonly: true
                },
                {
                    key: 'modified',
                    label: 'Fecha de Modificación',
                    type: 'datetime',
                    readonly: true
                }
            ],
        ]
    },
    dispoField = {
        key: 'disponibilidad',
        type: 'select',
        options: [
            'Accesible al usuario',
            'Solo admin'
        ],
        default: 'Accesible al usuario',
        sortable: true,
    },
    captions = [
        // { key: 'id_pk', label: 'PK' },
        // { key: 'id_usuario_fk', label: 'Usuario' },
        { key: '_', stickyColumn: true },
        { key: 'titulo', label: 'Título', sortable: true, stickyColumn: true },
        { key: 'url', label: 'URL',sortable: true },
        dispoField,
        // { key: 'tipo', label: 'Tipo', sortable: true },
        { key: 'created', label: 'Fecha de Creación', sortable: true },
        { key: 'modified', label: 'Fecha de Modificación', sortable: true },
    ],
    quicktableFilters = () => {
        const dispoFilter = {
            key: 'disponibilidad',
            required: true,
            options: ['Todos', ...dispoField.options],
            default: null
        };

        return [
            dispoFilter
        ]
    },
    archetypeUsuariosclientebinariosCFG = () => {
        return [
            // { key: 'id', type: 'hidden' },
            // { key: 'Usuariosclientebinarios_id', type: 'hidden', },
            // { key: 'descriptor', label: 'Description', readonly: true },
        ]
    };

let automodalHandler = (conceptId, args = {}) => {
    let str = baseController + '/define/' + ((_.isNil(conceptId)) ? 'null' : (conceptId));
    str += '/' + objectToUrlString(args);
    return str;
}


export {
    captions,
    baseIndex,
    archetype,
    archetypeUsuariosclientebinariosCFG,
    quicktableFilters,
    automodalHandler
}